export default "__VITE_ASSET__5l2wPS$6__"